import { EN_LOCALE, FR_LOCALE, ES_LOCALE } from 'constants/locales';

export const getLocale = () => {
  const language = window.navigator.language.toLowerCase();
  if (language.startsWith(FR_LOCALE)) return FR_LOCALE;
  if (language.startsWith(ES_LOCALE)) return ES_LOCALE;
  return EN_LOCALE;
};

export const countryToLocale = (country: string): typeof FR_LOCALE | typeof ES_LOCALE | typeof EN_LOCALE => {
  switch (country) {
    case 'FRA':
      return FR_LOCALE;
    case 'ESP':
      return ES_LOCALE;
    default:
      return EN_LOCALE;
  }
}